import PodcastPageConfig from "pages/podcast/config";
import Crunker from "crunker";
import { fetchFile } from "@ffmpeg/ffmpeg";

export const getSingleAudioFile = async (audioLinks: string[]) => {
  const crunker = new Crunker();

  const audio = [];
  for (const audioLink of audioLinks) {
    audio.push(`https://${audioLink}${PodcastPageConfig.ipfsGatewayUrl}`);
  }

  const audioFileUrl = crunker
    .fetchAudio(...audio)
    .then(buffers => {
      return crunker.concatAudio(buffers);
    })
    .then(concat => {
      return crunker.export(concat, "audio/mp3");
    })
    .then(output => {
      return output.url;
    })
    .catch(error => {
      return "";
    });
  return audioFileUrl;
};

interface GetSingleVideoFileProps {
  videoLinks: string[];
  ffmpeg: any;
}

export const getSingleVideoFile = async ({ videoLinks, ffmpeg }: GetSingleVideoFileProps) => {
  let myFile = "";
  for (let i = 0; i < videoLinks.length; i++) {
    const file = await fetchFile(`https://${videoLinks[i]}${PodcastPageConfig.ipfsGatewayUrl}`);
    await ffmpeg.FS("writeFile", `video${i}.mov`, file);
    myFile += `file video${i}.mov \n`;
  }
  await ffmpeg.FS("writeFile", "MyList.txt", myFile);

  await await ffmpeg.run("-f", "concat", "-safe", "0", "-i", "MyList.txt", "-c", "copy", "output.mp4");
  const data = await ffmpeg.FS("readFile", "output.mp4");
  const videoFileUrl = URL.createObjectURL(new Blob([data.buffer], { type: "video/mp4" }));
  return videoFileUrl;
};
